import React from 'react';
import ReactDOM from 'react-dom';
// Fela styling provider
import { Provider as FelaProvider } from 'react-fela';
import { createRenderer } from 'fela';
// MobX provider
import { Provider as MobxProvider } from 'mobx-react';
import { RootStore } from './stores';
import App from './App';

import './index.css';

const MobxStore = RootStore.create({});

ReactDOM.render(
  <FelaProvider renderer={createRenderer()}>
    <MobxProvider store={MobxStore}>
      <App />
    </MobxProvider>
  </FelaProvider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js